import React, { useEffect, useState } from 'react';
import { localStorage } from '../../../shared/utils/storage';
import Button from "../../../shared/components/atoms/button/button";
import GenericModal from '../../../shared/components/organisms/generic-modal/generic-modal';
import Input from "../../../shared/components/atoms/input/input"
import TransversalServices from '../../../shared/services/transversal-services';
import { useForm } from 'react-hook-form'
import formatNumber from '../../../shared/utils/formatNumber';
import useMobile from '../../../shared/hooks/useMobile';
import { GatsbyImage } from 'gatsby-plugin-image'
import './redeem-module-modal.scss'

const RedeemModuleModal = ({ mainCopy, missingPointsCopy, rewardImage, rewardCost, userData, acceptCopy, acceptEvent, cancelCopy, cancelEvent, closeModal }) => {

    const [userPoints, setUserPoints] = useState(userData.account.balance);

    const mobile = useMobile();
    const { register, setValue, getValues, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [inputmessage, setInputMessage] = useState("");
    const [typeResponse, setTypeResponse] = useState();

    useEffect(() => {
        document.documentElement.style.overflowY = 'hidden';
        document.body.scroll = "no";
        return () => {
            document.documentElement.style.overflowY = 'scroll';
            document.body.scroll = "yes";
        }
    }, [])

    function sendKey() {

        setMessage(null)
        setInputMessage(null)
        setTypeResponse(null)
        const tokenInfo = localStorage.getItem("TOKEN_INFO") ? localStorage.getItem("TOKEN_INFO") : null
        let pattern = /^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/
        if (pattern.test(getValues("key"))) {
            setLoading(true)
            let payload = {
                key: {
                    code: getValues("key")
                }
            }
            let config = {
                headers: {
                    Authorization: tokenInfo ? tokenInfo.idToken : null,
                },
            }

            TransversalServices.sendKey(payload, config).then(res => {
                setLoading(false)
                if (res.status === 200) {
                    setInputMessage("Clave correcta")
                    setTypeResponse("sucess")
                    setUserPoints(userPoints + res.data.points)
                    setMessage(<>Has sumado <span>{res.data.points} puntos</span> a tu banco</>)
                } else {
                    if (res.errorCode === "DEM187") {
                        setMessage(res.userMessage)
                    }
                    setInputMessage("Clave incorrecta")
                    setTypeResponse("error")
                }
            }).catch(e => console.log(e))
        } else {
            setInputMessage("Clave incorrecta")
            setTypeResponse("error")
        }
    }

    return (
        <div className="f-m-redeem-module-modal">
            <GenericModal closeModal={closeModal}>
                {userPoints !== null ?
                    <div className="f-m-redeem-module-modal__content">
                        {(userPoints < rewardCost) ?
                            <div className="f-m-redeem-module-modal__missing-points">
                                <div className="f-m-redeem-module-modal__missing-points-text">
                                    <h2 className="f-m-redeem-module-modal__title">Mi Banco de puntos</h2>
                                    <p className="f-m-redeem-module-modal__missing-points-label">{missingPointsCopy}</p>
                                    <div className="f-m-redeem-module-modal__missing-points-account">
                                        <p>Mi saldo actual de puntos:</p>
                                        <b>{formatNumber(userPoints) + " puntos"}</b>
                                    </div>
                                </div>
                                <div className="f-m-redeem-module-modal__keys-display">
                                    <div className="f-m-redeem-module-modal__image-container __keys">
                                        {(rewardImage && rewardImage[0]) &&

                                            rewardImage[0].gatsbyImageData ?
                                            <GatsbyImage
                                                image={rewardImage[0].gatsbyImageData}
                                                alt={rewardImage[0].description}
                                                className="f-m-redeem-module-modal__image"
                                            />
                                            :
                                            <img
                                                src={rewardImage[0].file.url}
                                                alt={rewardImage[0].description}
                                                className="f-m-redeem-module-modal__image"
                                            />
                                        }
                                        {rewardImage && rewardImage[1] &&
                                            <img
                                                src={rewardImage[1].file.url}
                                                alt={rewardImage[1].description}
                                                className="f-m-redeem-module-modal__second-image"
                                            />
                                        }
                                    </div>
                                    <div className="f-m-redeem-module-modal__content-right">
                                        <p className="f-m-redeem-module-modal__content-right-title">Ingresa tus claves:</p>
                                        <div className={"f-m-redeem-module-modal__input " + (typeResponse ? "f-m-redeem-module-modal__input-" + typeResponse : "")}>
                                            <Input
                                                label=""
                                                name="key"
                                                maxLength="60"
                                                type="text"
                                                placeholder="Ingresa tu clave"
                                                register={register}
                                                validationRules={
                                                    {
                                                        pattern:
                                                        {
                                                            value: /^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/,
                                                            message: 'No se permiten caracteres especiales'
                                                        }
                                                    }
                                                }
                                                setValue={setValue}
                                            />
                                            <p className="f-m-redeem-module-modal__input-copy">**Nuestras claves no se vencen</p>
                                            {inputmessage && <p className="f-m-redeem-module-modal__input-copy-input">{inputmessage}</p>}
                                        </div>
                                        <div className="f-m-redeem-module-modal__submit">
                                            <Button
                                                id="f-a-buttton__modal-key"
                                                className={"f-a-button__primary-purple f-a-button" + (mobile ? "__big" : "__extra-big")}
                                                copy="Ingresar clave"
                                                onclick={sendKey}
                                                loader={loading}
                                            />
                                            <Button
                                                id="f-a-buttton__modal-key-cancel"
                                                className={"f-a-button__secondary-purple f-a-button" + (mobile ? "__big" : "__extra-big")}
                                                copy={cancelCopy}
                                                onclick={cancelEvent}
                                                loader={loading}
                                            />
                                        </div>
                                        {message && <p className="f-m-redeem-module-modal__message">{message}</p>}
                                    </div>
                                </div>
                            </div>
                            :
                            <>
                                <div className="f-m-redeem-module-modal__information">
                                    {!mobile &&
                                        <div className="f-m-redeem-module-modal__image-container">
                                            {(rewardImage && rewardImage[0]) &&

                                                rewardImage[0].gatsbyImageData ?
                                                <GatsbyImage
                                                    image={rewardImage[0].gatsbyImageData}
                                                    alt={rewardImage[0].description}
                                                    className="f-m-redeem-module-modal__image"
                                                />
                                                :
                                                <img
                                                    src={rewardImage[0].file.url}
                                                    alt={rewardImage[0].description}
                                                    className="f-m-redeem-module-modal__image"
                                                />

                                            }
                                            {rewardImage && rewardImage[1] &&
                                                <img
                                                    src={rewardImage[1].file.url}
                                                    alt={rewardImage[1].description}
                                                    className="f-m-redeem-module-modal__second-image"
                                                />
                                            }
                                        </div>
                                    }
                                    <div className="f-m-redeem-module-modal__text">
                                        <h2 className="f-m-redeem-module-modal__title">Mi Banco de puntos</h2>
                                        <p className="f-m-redeem-module-modal__main-copy">{mainCopy}</p>
                                        {mobile &&
                                            <div className="f-m-redeem-module-modal__image-container">
                                                {(rewardImage && rewardImage[0]) &&

                                                    rewardImage[0].gatsbyImageData ?
                                                    <GatsbyImage
                                                        image={rewardImage[0].gatsbyImageData}
                                                        alt={rewardImage[0].description}
                                                        className="f-m-redeem-module-modal__image"
                                                    />
                                                    :
                                                    <img
                                                        src={rewardImage[0].file.url}
                                                        alt={rewardImage[0].description}
                                                        className="f-m-redeem-module-modal__image"
                                                    />

                                                }
                                                {rewardImage && rewardImage[1] &&
                                                    <img
                                                        src={rewardImage[1].file.url}
                                                        alt={rewardImage[1].description}
                                                        className="f-m-redeem-module-modal__second-image"
                                                    />
                                                }
                                            </div>
                                        }
                                        <div className="f-m-redeem-module-modal__user-points">
                                            <p>Mi saldo actual de puntos:</p>
                                            <b>{formatNumber(userPoints) + " puntos"}</b>
                                        </div>
                                        <p className="f-m-redeem-module-modal__cost">{"De tu saldo actual se te descontarán " + rewardCost + " puntos"}</p>
                                        <div className="f-m-redeem-module-modal__user-points-result">
                                            <p>Tu saldo final será:</p>
                                            <b>{formatNumber(userPoints - rewardCost) + " puntos"}</b>
                                        </div>
                                        <div className="f-m-redeem-module-modal__buttons">
                                            <Button
                                                id="f-a-button__redeem-module-modal-accept"
                                                className={"f-a-button__primary-purple f-a-button__big f-m-redeem-module-modal__button-accept"}
                                                copy={acceptCopy}
                                                onclick={acceptEvent}
                                            />
                                            <Button
                                                id="f-a-button__redeem-module-modal-cancel"
                                                className={"f-a-button__secondary-purple f-a-button__big f-m-redeem-module-modal__button-cancel"}
                                                copy={cancelCopy}
                                                onclick={cancelEvent}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    :
                    <div className="f-m-redeem-module-modal__loader-container">
                        <div className="f-m-redeem-module-modal__loader" />
                    </div>
                }
            </GenericModal>
        </div>
    )
}

export default RedeemModuleModal
